/* src/app/error-page/error-page.component.scss */
.error-message-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 500px;
  text-align: center;
}
.error-message-container__header {
  margin-top: 50px;
  padding-bottom: 0;
  color: #232d31;
  font-weight: 300;
  font-size: 3rem;
  padding-top: 0;
  margin-bottom: 11px;
}
@media (min-width: 768px) {
  .error-message-container__header {
    font-size: 4.5rem;
  }
}
.error-message-container__text {
  font-style: normal;
  font-size: 1.6rem;
  color: #232d31;
  padding-top: 30px;
}
.error-message-container__phone-number a {
  color: #006990 !important;
  white-space: nowrap;
  display: block;
  font-size: 1.6rem;
}
/*# sourceMappingURL=error-page.component-3WQR7T4C.css.map */
